// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__UFGyP","opacity-transition":"success_opacity-transition__cc5Eq"};